import { Stack, TextField, Typography, Box, Grid, Chip } from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { obtenerFechaHoyISO } from "../../utils/horaLocal";

export default function VentaSubRow({ prod, subDates, onChangeSubDate }) {
  const val = subDates?.[prod.id] || {};

  const handleField = (field) => (e) => {
    onChangeSubDate(prod.id, { ...val, [field]: e.target.value });
  };

  return (
    <Box sx={{ p: 1.5, bgcolor: "tint.pipeline", borderRadius: 2, border: "1px dashed", borderColor: "info.main" }}>
      <Stack direction="row" spacing={1} alignItems="center" mb={1}>
        <AutorenewIcon sx={{ color: "info.main", fontSize: 18 }} />
        <Typography variant="caption" fontWeight={700} color="info.dark">Suscripción: {prod.nombre}</Typography>
      </Stack>
      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Fecha inicio"
            value={val.startDate || obtenerFechaHoyISO()}
            onChange={handleField("startDate")}
            type="date"
            size="small"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <TextField
            label="Vigencia (días)"
            value={val.validityDays || prod.diasVigencia || 30}
            onChange={handleField("validityDays")}
            type="number"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <TextField
            label="Recordar antes (días)"
            value={val.reminderDays || prod.diasRecordatorio || 7}
            onChange={handleField("reminderDays")}
            type="number"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
}
